'use strict';

var $ = require('jquery');
var Modal = require('../lib/Modal.js');

function setupWarrantyModal() {
	var modal = new Modal('mw', {className: 'modal modal--warranty'});
	modal._original;
	modal.getStateTitle = function() {
		if (this.state !== undefined && this.state.href != undefined) {
			return '(Full)';
		}
		return null;
	}
	
	$('.listItemGroup__link a[href*=warranty]').on('click', function(e) {
		e.preventDefault();
		modal.open({href: this.getAttribute('href') + ' .section'});
	});
	
	if ($('#warrantyRegistrationForm').length != 0) {
		$('#warrantyRegistrationForm').on('click', 'a[href*=warranty]', function(e) {
			e.preventDefault();
			modal.open({href: this.getAttribute('href') + ' .section'});
		});
	}
	
	if ($('#warrantyListing').length != 0) {
		$('#warrantyListing').on('click', 'a[href*=warranty]', function(e) {
			e.preventDefault();
			modal.open({href: this.getAttribute('href') + ' .section'});
		});
	}
	
	$("#success-page-print").on("click", function(e) {
		e.preventDefault();
		window.print();
	});
}

module.exports = {
	init : function() {
		if ($('body.__warranty, #warrantyRegistrationForm, #warrantyListing').length === 0)
			return;
		
		setupWarrantyModal();
	}
};

